export const PRIORITY_OPTIONS = [
  { value: "emergency_urgent", label: "Emergency / Urgent" },
  { value: "guest_arrival_readiness", label: "Guest Arrival Readiness" },
  { value: "preventative_maintenance", label: "Preventative Maintenance" },
  { value: "projects_improvements", label: "Projects / Improvements" },
  { value: "high", label: "High" },
  { value: "medium", label: "Medium" },
  { value: "low", label: "Low" },
];

export const PRIORITY_LABELS = PRIORITY_OPTIONS.reduce((labels, option) => {
  labels[option.value] = option.label;
  return labels;
}, {});

export const getPriorityLabel = (priority) => {
  const key = String(priority || "").trim().toLowerCase();
  return PRIORITY_LABELS[key] || priority || "";
};

export const getPriorityClassName = (priority) =>
  String(priority || "other").trim().toLowerCase().replace(/[^a-z0-9_-]+/g, "-");
